import { GridViewRounded, ViewListRounded } from '@mui/icons-material'
import { InputAdornment, Stack, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import SegmentedControls from './SegmentedControls'
import { useState } from 'react'

type StudiesOverviewHeaderProps = {
  activeControl: number
  setActiveControl: (val: number) => void
  onSearch: (searchTerm: string) => void
}

const StudiesOverviewHeader = ({ activeControl, setActiveControl, onSearch }: StudiesOverviewHeaderProps) => {
  const [inputValue, setInputValue] = useState('')

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch(inputValue)
    }
  }

  return (
    <Stack direction="row" justifyContent="space-between" data-testid="studies-overview-header">
      <Stack
        direction="row"
        justifyItems="center"
        justifyContent="space-between"
        width="100%"
        data-testid="header-controls"
      >
        <SegmentedControls
          value={activeControl}
          setValue={setActiveControl}
          controls={[
            { icon: <GridViewRounded data-testid="grid-view-icon" /> },
            { icon: <ViewListRounded data-testid="list-view-icon" /> },
          ]}
        />
        <TextField
          data-testid="search-field"
          variant="outlined"
          size="small"
          label="Search study"
          value={inputValue}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          sx={{
            boxShadow: 1,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon data-testid="search-icon" />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
    </Stack>
  )
}

export default StudiesOverviewHeader
